// extracted by mini-css-extract-plugin
export default {"root":"Menu_root__nS-JI","item":"Menu_item__QOVow","selectedItem":"Menu_selectedItem__JOXJd"};